<template>
  <div class="home">
    <p class="note note-primary">
      <strong
        >Current Event:
        <router-link to="/world/Ev12/"
          >Lightless Sanctuary</router-link
        ></strong
      >
    </p>
    <h2>
      <br />An Enemy Information Site for the Mobile Game Last Ogirin
    </h2>
  </div>
  <hr />
  <p>
    Original Last Origin Map:
    <a href="https://lastoriginmap.github.io/index.html">Link</a>
  </p>
  <p>
    Original Site (Swaytwig):
    <a href="https://lo.swaytwig.com">Link</a>
  </p>
  <p>
    English Wiki:
    <a href="https://lastorigin.fandom.com/wiki/Last_Origin_Wiki">Link</a>
  </p>
  <p>
    Discord Server:
    <a href="https://discord.gg/wedonttalkboutmodserver">Link</a>
  </p>
  <p>
    Alternative Discord Server:
    <a href="https://discord.gg/jPHsNx8">Link</a>
  </p>
  <hr />
  <p>
    All resources like equipment and unit icon, data values that is used on
    <i class="">SmartJoy</i>'s <i class="">LastOrigin</i> is the property of
    <i class="">SmartJoy</i>. All rights of the resources belong to
    <i class="">SmartJoy</i>.
  </p>
</template>

<script>
export default {
  name: "Home",
  created() {
    document.title = "Home";
  },
};
</script>

<style scoped>
i {
  background-color: #eee;
  border-radius: 3px;
  padding: 1px 4px;
}
</style>
